module.exports = __webpack_public_path__ + "img/now-buy.02264ec5.png";